import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {xcService} from "../../../_services/xcService";
import {DownloadOutlined, RightOutlined, ShareAltOutlined} from "@ant-design/icons";
import {Button, Table} from "antd";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";
import {Select, Space} from 'antd';
import {history} from '_helpers/history'

function InformesView({user, student, family}) {
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [userData, setUserData] = useState(user ?? userStorage)
    const {t} = useTranslation();
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [years, setYears] = useState([]);
    const [yearActual, setYearActual] = useState([]);
    const userType = storage.getItem(variables.USER_TYPE);

    useEffect(() => {
        xcService.get(`/v1/years`).then(({data}) => {


            let mYears = [];
            data.data.map(it => {
                mYears.push({
                    value: it.year,
                    label: "20" + it.year + "/20" + (+it.year + 1),
                },)
            })
            setYears(mYears)

            let mActual = data.data.filter(it => it.old === false);
            if (mActual && mActual[0]) {
                setYearActual(mActual[0].year)
            } else {
                setYearActual(22)
            }
        })

        xcService.getToken(`/v1${userType !== "STUDENT" ? '/tutor' : ''}/questionnaire/informes/${userData.uid}`)
            .then(({data}) => {
            });


        xcService.getToken(`/v1${userType !== "STUDENT" ? '/tutor' : ''}/questionnaire/informes/${userData.uid}`)
            .then(({data}) =>
                data.data.filter(data => data.count <= data.numberOfQuestions))
            .then((data) =>
                data.sort((a, b) => a.year > b.year ? -1 : 1).map(data => {


                    return {
                        ...data,
                        name: `${data.name.replace(t("datos.cuestionde"), '')}`,
                        year: `${data.year}/${data.year + 1}`,
                        years: data.year,
                        view: <a className={"btn-icon-text"} target={student ? "_self" : "_blank"}
                                 href={`/admin/informes/${student ? '' : 'd'}${data.code}?user=${userData.uid}&year=${data.year}`}>
                            <span>{t('informes.tableViewReportColHeading')}</span>
                            <RightOutlined/>
                        </a>
                    }
                }))
            .then(data => setData(data))
    }, [t])

    const columns = [
        {
            title: t('informes.tableReportColHeading'),
            dataIndex: 'name',
            render: (text) => <p className={"text-data text-data--visibility"}>{text}</p>,
        },
        {
            title: t('informes.tableYearColHeading'),
            dataIndex: 'year',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
        {
            title: t('informes.tableCourseColHeading'),
            dataIndex: 'courseName',
            render: (text) => <p className={"text-data text-data--small"}>{text}</p>,
        },
        {
            title: '',
            dataIndex: 'view',
            render: (text) => <div className={"text-show-data text-data--visibility"}>{text}</div>,
        },
    ];

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {

            setSelectedRows(selectedRows)
        },
        getCheckboxProps: (record) => ({
            disabled: false,
            name: record.report,
        }),
    };

    const downloadPDF = async () => {
        let mTek = false;
        let mCervo = false;
        let mCeiba = false;
        let mYear = yearActual;
        selectedRows.map(data => {

            mYear = data.years
            if (data.code.includes("TEK")) {
                mTek = true;
            }
            if (data.code === "CERVO") {
                mCervo = true;
            }
            if (data.code === "CEIBA") {
                mCeiba = true;
            }
        });
        let mUrl = `/admin/informes/dinformes?user=${userData.uid}&year=${mYear}&tek=${mTek}&ceiba=${mCeiba}&cervo=${mCervo}`;
        history.push(mUrl)
        //window.open(mUrl, '_blank');

    }
    const handleChange = (value) => {
        setYearActual(value)
    };
    return <>

        <div className={"informes-header"}>
            <div className={"informes-header__bottom"}>
                {!family &&
                    <div className={"informes-header__bottom-right"}>
                        <Button onClick={() => downloadPDF()} disabled={selectedRows.length < 1}
                                className={"btnWhiteBlue"}><DownloadOutlined/>{t("informes.downloadButton")}
                        </Button>
                        {1 == 2 && <Button className={"btnWhiteBlue"}><ShareAltOutlined/>{t("informes.shareButton")}
                        </Button>}
                    </div>
                }
            </div>
        </div>

        <p>{t("filtraporyear")} <Select
            value={yearActual}
            style={{width: 120}}
            onChange={handleChange}
            options={years}
        /></p>

        <Table
            className={"table-informes"}
            pagination={{position: ['bottomCenter']}}
            rowKey={"key"}
            rowSelection={!family ? {
                type: 'checkbox',
                ...rowSelection,
            } : false} columns={columns}
            dataSource={data.filter(it => it.years === yearActual)}
        />

    </>
}

export default InformesView;
